module.exports = __webpack_public_path__ + "static/codesuggestions-bf16b6129faa26dbf2b4d8cd5bf2a819.png";